import React from "react";

import FileUploader from "../FileUploader";
import useFileUploader from "../../../hooks/useFileUploader";

import { FileInterface } from "../../../types/common";

import * as api from "../modules/api";

interface Props {
  onChange: (updatedValue: FileInterface[], isValidated?: boolean) => void;
  path: string;
  files: FileInterface[];
  maxSize?: number;
  maxFiles?: number;
  isViewOnly?: boolean;
  isReadonlyMode?: boolean;
  isDownloadActive?: boolean;
  uploadKey?: string;
  externalHintText?: string;
}

const acceptMimeTypes = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

const DraftFileUploaderContainer = (props: Props) => {
  const { files, onChange, uploadKey = "Files", externalHintText, ...rest } = props;
  const { filesRef, ...fileUploaderProps } = useFileUploader({
    ...rest,
    files,
    onChange,
    externalHintText,
    uploadFile: (params) => api.uploadDraftFile({ ...params, key: uploadKey }),
    acceptMimeTypes: acceptMimeTypes
  });

  const onRemove = (id: string) => {
    const updatedData = files.filter((item) => item.id !== id);

    onChange(updatedData);
  };

  const onDescriptionBlur = async (id: string, description: string) => {
    const currentFile = filesRef.current.find((i) => i.id === id);
    const isDescriptionChanged = currentFile?.description !== description;

    if (isDescriptionChanged) {
      onChange(
        filesRef.current.map((f) => (f.id === id ? { ...f, description } : f))
      );
    }
  };

  const onDownload = (path: string, fileName: string) =>
    api.downloadDraftFile(path, fileName);

  return (
    <FileUploader
      multiple
      id="file-uploader"
      onRemove={onRemove}
      onDownload={onDownload}
      onDescriptionBlur={onDescriptionBlur}
      {...fileUploaderProps}
      {...rest}
    />
  );
};

export default DraftFileUploaderContainer;
